export function getFileHref(path: string): string {
  return `chg-${path}`;
}
